module.exports = __webpack_public_path__ + "static/media/bg_for_dost_angry.6c5d4164.jpg";